export default __webpack_public_path__ + "static/media/jayne-saturday.55e53b23.jpeg";